module.exports = __webpack_public_path__ + "static/side-img-8-66cec423a274a5485b0e2ffa91509b54.png";